import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"

export function RejectTailoringButton() {
    const { tailoringAudit, setRejection, isEditable = true } = useBoundContext()

    return (
        <If truthy={!tailoringAudit?.payload?.rejection?.reason && !isEditable}>
            <RegimeDraftLockHide>
                <Button
                    color="error"
                    onClick={handleClick}
                    size="small"
                    startIcon={<Iconify icon="ic:round-clear" />}
                    data-cy="reject-tailoring-button"
                >
                    Reject
                </Button>
            </RegimeDraftLockHide>
        </If>
    )

    function handleClick() {
        setRejection({ reason: "" })
    }
}
